import _ from 'lodash';
import React, { PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// actions
import * as actions from './../../../../actions/actions';

// selectors
import { hasValueWidgetsOnPage } from './../../../../selectors/selectors';

// components
import BackButton from './Back';
import NextButton from './Next';
import SendButton from './Send';

class NavButtonsContainer extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { app, activeId, pagesList, results, pageWithValue, actions } = this.props;

        const backButton = () => {
            if (activeId !== _.first(pagesList)) {
                return <BackButton activeId={activeId} pagesList={pagesList} actions={actions} />;
            } else {
                return null;
            }
        };

        const nextButton = () => {
            const nextBtn = <NextButton activeId={activeId} pagesList={pagesList} actions={actions} />;
            
            if (activeId !== _.last(pagesList)) {
                if (pageWithValue && app.mode !== 'EDIT') {
                    if (_.has(results, activeId) && activeId !== pagesList[pagesList.length - 2]) {
                        return nextBtn;
                    }
                } else {
                    if (activeId === pagesList[pagesList.length - 2]) {
                        return null;
                    } else {
                        return nextBtn;
                    }
                }
            } else {
                return null;
            }
        };

        const sendButton = () => {
            if (activeId === pagesList[pagesList.length - 2]) {
                if (pageWithValue && app.mode !== 'EDIT') {
                    if (_.has(results, activeId)) {
                        return <SendButton app={app} actions={actions} />;
                    }
                } else {
                    return <SendButton app={app} actions={actions} />;
                }
            } else {
                return null;
            }
        };

        return (
            <div className="nav-btns">
                { backButton() }
                { nextButton() }
                { sendButton() }
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    app: state.app,
    activeId: state.pages.activeId,
    pagesList: state.pages.list,
    results: state.results,
    pageWithValue: hasValueWidgetsOnPage(state),
});

const mapDispatchToProps= (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
});

NavButtonsContainer.propTypes = {
    app: PropTypes.object.isRequired,
    activeId: PropTypes.number.isRequired,
    pagesList: PropTypes.array.isRequired,
    results: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array,
    ]),
    pageWithValue: PropTypes.bool.isRequired,
    actions: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(NavButtonsContainer);



// WEBPACK FOOTER //
// ./src/_app/quick_response/components/Content/UI/NavButtons/NavButtonsContainer.jsx